<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/ica/ICA%E5%B9%BF%E5%91%8A%E9%A1%B5.png"
			alt="" />
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">产品核心</div>
		<div class="title-desc">构建全流程智慧化赋能平台</div>
		<div class="desc">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;面向规模农业种植企业和农业各级主管机构打造的智能管理服务平台，基于于广空天地(卫星、无人机、物联网)多源数据集成能力和全球领先算法，从管理和技术两个维度为农业赋能，通过以智慧决策为核心的技术实现种植管理的全程管控，并提供一站式智慧农业建设服务和全环节数据数字化可留存分析，辅助高效、精准种植监管，实现防灾减损、降本增效、增产增收。
		</div>
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">产品架构</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/ica/%E4%BA%A7%E5%93%81%E6%9E%B6%E6%9E%84.png"
			alt="" />

		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">ICA大数据中心</div>
		<div class="title-desc">融合领先的算法、遥感技术和首创的产供销一体应用模型赋能三农</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/ica/%E5%A4%A7%E6%95%B0%E6%8D%AE%E4%B8%AD%E5%BF%83.png"
			alt="" />

		<div class="flex justb" style="width: 70%;flex-wrap: wrap;">
			<div class="sj-cont">海量公开数据</div>
			<div class="sj-cont">AI智能分析</div>
			<div class="sj-cont">及时权威动态</div>
			<div class="sj-cont">实时信息预警</div>
			<div class="sj-cont">多维信息聚合</div>
			<div class="sj-cont">数据精准推送</div>
			<div class="sj-cont">多维适配展示</div>
			<div class="sj-cont">深度数据查询</div>
			<div class="sj-cont">驾驶舱-展示数据</div>
			<div class="sj-cont">应用后台-使用数据</div>
			<div class="sj-cont">智能报告-分析数据</div>
			<div class="sj-cont">移动端-携带数据</div>
		</div>
		<div class="desc" style="margin-top: 20px;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过公开线上线下全网海量的大数据，在合规技染脱敏后的形成分类聚合，利用知设图谱及大数据分析等能力，打造集体息分类、舆情监测、智能报表、数摇行阅、产业地图、济格指数、双磋资讯、农村电商等功能于一体的全国大型在线大数据服务理台，为政府机构、科研院校、行业协会、龙头企业提供一站式大数据应用购务。
		</div>
		
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">数字服务</div>
		<img style="width: 80%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/ica/%E6%95%B0%E5%AD%97%E6%9C%8D%E5%8A%A12.png"
			alt="" />
		<img 
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/ica/2024_06_21_c0c602a858ef40bf9b34fa4f14cde7fb.jpg"
			alt="" />
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 22px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>